import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import Icon from "../Icon";
var cx = classNames.bind(styles);
var Checkbox = function Checkbox(props) {
  var children = props.children,
    name = props.name,
    checked = props.checked,
    disabled = props.disabled,
    handleChange = props.handleChange,
    className = props.className;
  var id = "checkbox__".concat(name);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('layout', {
      disabled: disabled
    }, className),
    "data-t-id": "components-Checkbox"
  }, /*#__PURE__*/React.createElement("input", {
    checked: checked,
    className: cx('absolute', 'field'),
    "data-component": "Checkbox",
    disabled: disabled,
    id: id,
    name: name,
    onChange: handleChange,
    type: "checkbox"
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('absolute', 'checkbox', {
      checked: checked
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    className: cx('icon', {
      checked: checked
    }),
    name: "checked"
  })), children ? /*#__PURE__*/React.createElement("label", {
    className: cx('label'),
    htmlFor: id
  }, children) : null);
};
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any,
  name: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
} : {};
export default Checkbox;